// src/pages/Projects.js
import React, { useEffect, useState } from 'react';
import { authFetch } from '../utils/authFetch';
import ProjectList from '../components/ProjectList';
import AddProjectModal from '../components/AddProjectModal';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [sortBy, setSortBy] = useState('created_at');
  const [clientFilter, setClientFilter] = useState('');

  const fetchProjects = () => {
    authFetch('/projects/')
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch projects');
        return res.json();
      })
      .then((data) => {
        const results = Array.isArray(data) ? data : data.results || [];
        setProjects(results);
      })
      .catch((err) => {
        console.error(err);
        setError('Something went wrong loading projects.');
      });
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const handleSort = (a, b) => {
    if (sortBy === 'title') {
      return (a.title || '').localeCompare(b.title || '');
    }
    if (sortBy === 'created_at') {
      return new Date(b.created_at) - new Date(a.created_at);
    }
    return 0;
  };

  const filteredAndSorted = projects
    .filter((p) =>
      clientFilter.trim()
        ? (p.client_names || []).join(', ').toLowerCase().includes(clientFilter.toLowerCase())
        : true
    )
    .sort(handleSort);

  return (
    <div className="p-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
        <h2 className="text-2xl font-bold text-gray-800">Your Projects</h2>
        <button
          onClick={() => setShowModal(true)}
          className="bg-orange-500 hover:bg-orange-600 text-white text-sm px-4 py-2 rounded"
        >
          ➕ New Project
        </button>
      </div>

      {error && <p className="text-red-600 mb-4">{error}</p>}

      <div className="flex flex-col md:flex-row items-start md:items-center gap-4 mb-4">
        <input
          type="text"
          placeholder="Filter by client name..."
          value={clientFilter}
          onChange={(e) => setClientFilter(e.target.value)}
          className="border border-gray-300 px-3 py-2 rounded w-full md:w-64"
        />
        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          className="border border-gray-300 px-3 py-2 rounded"
        >
          <option value="created_at">Sort by: Date (Newest First)</option>
          <option value="title">Sort by: Title (A–Z)</option>
        </select>
      </div>

      <ProjectList
        projects={filteredAndSorted}
        onSelect={(project) => console.log('✅ Selected project:', project)}
        onAddProject={() => setShowModal(true)}
      />

      {showModal && (
        <AddProjectModal
          onClose={() => setShowModal(false)}
          onProjectAdded={() => {
            fetchProjects();
            setShowModal(false);
          }}
        />
      )}
    </div>
  );
};

export default Projects;